import { StyleCollection } from '@/utils/types';
import styled from '@emotion/styled';
import LaunchIcon from '@mui/icons-material/Launch';
import Button from '../Buttons/Button';

const Container = styled.div`
    display: flex;
    position: relative;
    align-items: center;
`;

const Content = styled.span`
    display: flex;
    font-size: 1.5rem;
    margin-left: 3rem;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.secondary.main};
`;

const Title = styled.span`
    font-size: clamp(1rem, 1.5vw, 2rem);
    font-weight: 700;
    margin-right: 1rem;
    display: flex;
    align-items: center;
    gap: 8px;
`;

const Subtitle = styled.span`
    font-size: 2rem;
`;

const styles: StyleCollection = {
    cta: {
        marginLeft: '2rem',
        marginRight: '4rem',
        textTransform: 'none',
        fontWeight: 600,
    },
};

export interface Props {
    type?: string;
    title?: string;
    subtitle?: string;
    ctaText: string;
    onCta: () => void;
    icon?: JSX.Element;
    ctaIcon?: JSX.Element;
    hideLaunchIcon?: boolean;
    disableCta?: boolean;
}

const CtaBanner = ({ title, subtitle, ctaText, onCta, icon, ctaIcon, hideLaunchIcon = false, disableCta }: Props) => {
    return (
        <Container>
            <Content>
                <Title>
                    {icon}
                    {title}
                </Title>
                <Subtitle>{subtitle}</Subtitle>
            </Content>
            {!!onCta && (
                <Button
                    variant="outlined"
                    startIcon={ctaIcon}
                    color="secondary"
                    aria-label="banner cta"
                    onClick={onCta}
                    sx={styles.cta}
                    disabled={disableCta}>
                    {ctaText}
                    {!(ctaIcon || hideLaunchIcon) ? <LaunchIcon sx={{ marginLeft: '0.5rem' }} /> : null}
                </Button>
            )}
        </Container>
    );
};

export default CtaBanner;
